import React, { useEffect, useState } from 'react';
import './App.css';
import NavBar from './Components/NavBar';
import {
	BrowserRouter as Router,
	Switch,
	Route,
	Redirect,
} from 'react-router-dom';
import Items from './Components/Items';
import Axios from 'axios';
import { commerce, random } from 'faker';
import UserContext from './context/UserContext';
import CartItems from './Components/CartItems';
import CheckOut from './Components/CheckOut';
import ProductDetails from './Components/ProductDetails';

const API_KEY = '563492ad6f91700001000001d00c9e12894e4b339200b67dea5bbb58';
const URL = 'https://api.pexels.com/v1/search?query=';

function App() {
	const [viewProduct, setViewProduct] = useState(false);

	const [product, setProduct] = useState({});
	const [pay, setPay] = useState(false);
	const [cart, setCart] = useState(false);
	const [query, setQuery] = useState('');
	const [productItem, setProductItem] = useState([]);
	const [cartItem, setCartItem] = useState([]);
	const [total, setTotal] = useState(0);
	const [paid, setPaid] = useState(false);
	const changeTotal = () => {
		var temp = 0;
		console.log(cartItem);
		cartItem.map((item) => {
			return (temp += Number(item.noItem) * Number(item.productPrice));
		});
		setTotal(temp);
	};
	const checkCart = (item) => {
		const temp = cartItem.filter((product) => product.id === item.id);
		return temp.length === 0;
	};

	const changeNoItem = (item, e) => {
		item.noItem = e.target.value;
		changeTotal();
	};
	const removeCartItem = (item) => {
		item.noItem = 0;
		changeTotal();
		item.noItem = 1;
		const temp = cartItem.filter((product) => product.id !== item.id);
		setCartItem(temp);
	};
	const fetchData = async () => {
		try {
			var q = query;
			if (query.length === 0) q = 'random';
			const { data } = await Axios.get(URL + q, {
				headers: {
					Authorization: API_KEY,
				},
			});
			const photos = data.photos;
			const temp = photos.map((photo) => ({
				img: photo.src?.tiny,
				small: photo.src?.small,
				id: photo.id,
				owner: photo.photographer,
				category: query,
				productPrice: commerce.price(),
				productName: random.word(),
				noItem: 1,
			}));
			setProductItem(temp);
		} catch (err) {
			console.log(err);
		}
	};
	useEffect(() => {
		fetchData();
	}, []);
	return (
		<div className="App">
			<Router>
				<UserContext.Provider
					value={{
						query,
						setQuery,
						cartItem,
						setCartItem,
						productItem,
						setProductItem,
						cart,
						setCart,
						removeCartItem,
						checkCart,
						changeNoItem,
						total,
						setTotal,
						changeTotal,
						fetchData,
						pay,
						setPay,
						paid,
						setPaid,
						product,
						setProduct,
						viewProduct,
						setViewProduct,
					}}
				>
					<NavBar />
					<Redirect to="/viewItems" />
					<Switch>
						<Route exact path="/viewItems" component={Items} />
						<Route exact path="/CartItems" component={CartItems} />
						<Route exact path="/CheckOut" component={CheckOut} />
						<Route exact path="/productDetails" component={ProductDetails} />
					</Switch>
				</UserContext.Provider>
			</Router>
		</div>
	);
}

export default App;
